export default __webpack_public_path__ + "static/media/FordAntennaComp-MediumItalic.94ca87b5.ttf";